import { AnalyticsContainer } from "../../containers/AnalyticsContainer";

export const Analytics = () => {
	return <AnalyticsContainer />;
};
